<template>
  <div class="flow">
    <router-view :analyzer="analyzer" @update="updateAnalyzer"/>
  </div>
</template>

<script>
export default {
  name: 'CreateAnalyzerFlow',
  data () {
    return {
      analyzer: {
        analyzerType: null,
        dataSources: {
          documents: [],
          websites: [],
          plainText: ''
        },
        name: 'New Model ' + new Date().toLocaleDateString('nl-NL'),
      }
    }
  },
  methods: {
    updateAnalyzer (analyzerData) {
      this.analyzer = {
        ...this.analyzer,
        ...analyzerData
      }
    },
  }
}
</script>

<style scoped>

.flow {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}



</style>



// WEBPACK FOOTER //
// src/components/CreateModelFlow/CreateAnalyzerFlow.vue